import { Breakpoint } from '@mui/system/createTheme';
import { gridColumnProperties } from 'src/types/gridColumnProperties';
import { UserSetting } from 'src/types/userSetting';

export const propertiesToSaveToLocalStorage: string[] = ['orderIndex', 'field', 'width', 'display', 'locked'];

export function getSettingsWidth(contentWidth: string | null | undefined): Breakpoint {
  if (!contentWidth) {
    return 'lg';
  }
  if (contentWidth === 'fullWidth') {
    return 'xxl' as Breakpoint;
  } else if (contentWidth === 'compact') {
    return 'lg' as Breakpoint;
  } else {
    return 'xl' as Breakpoint;
  }
}

export function getPageSizeSetting(userSettings: UserSetting[], key: string, defaultValue: number = 10): number {
  const pageSizeSetting = userSettings.find((setting) => setting.settingKey === key);

  if (!pageSizeSetting || !pageSizeSetting.settingValue) {
    return defaultValue;
  }

  if (typeof pageSizeSetting.settingValue === 'number') {
    return pageSizeSetting.settingValue;
  }

  if (typeof pageSizeSetting.settingValue === 'string') {
    const parsedValue = parseInt(pageSizeSetting.settingValue, 10);
    return isNaN(parsedValue) ? defaultValue : parsedValue;
  }

  return defaultValue;
}

export function getStrippedDownGridColumnArray(cols: gridColumnProperties[]): gridColumnProperties[] {
  let strippedDownColData = cols.map((c) => {
    let newCol = propertiesToSaveToLocalStorage.reduce((gridColumn: gridColumnProperties, fieldName) => {
      if (c[fieldName] !== undefined) {
        gridColumn[fieldName] = c[fieldName];
      }
      return gridColumn;
    }, {});
    return newCol;
  });
  return strippedDownColData;
}

export function mergeColumnsIntoDefaultColumns(strippedDownCol: gridColumnProperties[], defaultColumns: gridColumnProperties[]): gridColumnProperties[] {
  let mergedCols = defaultColumns.map((c) => {
    let newCol = {};
    let strippedCol = strippedDownCol.find((x) => x.field === c.field);
    if (strippedCol) {
      newCol = { ...c, ...strippedCol };
    } else {
      newCol = { ...c };
    }
    return newCol;
  });

  return mergedCols;
}
